<template>
<v-expansion-panel-content>

<!-- Рентабельность текущий месяц -->
    <v-row>
        <v-col
            cols="5">
            <span class="headline orangeMain--text">
                {{ shop.margin }}%
            </span>
            <span class="ml-3 blue-grey--text text--lighten-5 font-weight-thin">
                маржа
            </span>
            <br>
        <span
                class="headline"
                :class="shop.averCheck == 0 ? 'grey--text' : ''">
                {{ shop.averCheck | moneyT }}
        </span>
            <span class="font-weight-thin">
                р.
            </span>
            <span class="ml-1 blue-grey--text text--lighten-5 font-weight-thin">
                ср.ч
            </span>
        </v-col>

        <v-col
            cols="7"
            class="text-right" >
            <span class="display-3 ">
                {{ shop.profit | moneyM }}
            </span>
        </v-col>
    </v-row>

<!-- Продажи текущий месяц -->
    <v-row>
        <v-col cols="7">
            <span class="headline">
                {{ shop.factP }}%
            </span>
            <v-icon
                v-if="shop.prognosisP < 95"
                class="pb-2 red--text text--lighten-1">
                trending_down
            </v-icon>
            <v-icon
                v-else
                class="pb-2 orangeMain--text">
                trending_up
            </v-icon>
            <span class="headline orangeMain--text">
                {{ shop.prognosisP }}%
            </span>
            <br>
            <span class="blue-grey--text text--lighten-5 font-weight-thin">
                продажи / прогноз
            </span>
        </v-col>

        <v-col
            cols="5"
            class="text-right" >
            <span class="headline">
                {{ shop.factM | moneyM }}
            </span>
            <br>
            <v-icon class="pb-2 orangeMain--text">
                outlined_flag
            </v-icon>
            <span class="headline orangeMain--text">
                {{ shop.planM | moneyM }}
            </span>
        </v-col>
    </v-row>



    <v-icon
        class="font-weight-thin grey--text"
        >
        people_outline
    </v-icon>
    {{shop.returnN}}
    <span
        class="ml-2 orangeMain--text"
        >
        {{shop.factM ? (shop.returnM / shop.factM * 100).toFixed() : 0}}%
    </span>
    <span
        class="ml-2"
        >
        {{shop.returnM | money}}
    </span>
    <span
        class="blue-grey--text text--lighten-5 font-weight-thin"
        >
        р.
    </span>
        <br>

    <span
        class="blue-grey--text text--lighten-5 font-weight-thin"
        >
        возвраты
    </span>

    <v-row>
        <v-col class="text-center">
        <v-divider></v-divider>
        </v-col>
    </v-row>

<!-- Смена текущий день -->
    <v-row>
        <v-col cols="7">
            <v-icon class="pb-2 orangeMain--text">
                speed
            </v-icon>
            <span class="headline">
                {{ today.factP }}%
            </span>
            <br>
            <span class="blue-grey--text text--lighten-5 font-weight-thin">
                выполнение
            </span>
        </v-col>

        <v-col
            cols="5"
            class="text-right" >
            <span class="headline">
                {{ today.factM | moneyM }}
            </span>
            <br>
            <v-icon class="pb-2 orangeMain--text">
                outlined_flag
            </v-icon>
            <span class="headline orangeMain--text">
                {{ today.planM | moneyM }}
            </span>
        </v-col>
    </v-row>

<!-- Средний чек покупатель -->
    <v-row>
        <v-col
            cols="8"
            :class="today.averCheck == 0 ? 'grey--text' : ''">
            <span class="headline">
                {{ today.averCheck | moneyT }}
            </span>
            <span class="font-weight-thin">
                р.
            </span>
            <br>
            <span class="blue-grey--text text--lighten-5 font-weight-thin">
                ср.ч смена
            </span>
        </v-col>

        <v-col
            cols="4"
            class="text-right" >

            <v-icon
                class="pb-2 font-weight-thin"
                :class="today.averCheck == 0 ? 'grey--text' : ''">
                people_outline
            </v-icon>
            <span
                class="headline"
                :class="today.averCheck == 0 ? 'grey--text' : ''">
                {{ today.averCheckN }}
            </span>
            <span class="blue-grey--text text--lighten-5 font-weight-thin">
                покупатели
            </span>
        </v-col>
    </v-row>

<!-- График -->
    <v-card flat min-height="360" class="blueDark">
    <apexchart v-if="graph"
        type="line"
        :options="options"
        :series="series">
    </apexchart>
    </v-card>

</v-expansion-panel-content>
</template>

<script>

import {mapState} from 'vuex';

export default {
name: 'Shop',
props: {
    shopid: {
        type: String,
    },
},

data: () => ({
    shop: {},
    graph: false,
    series: [
      {
        name: 'sellings',
        type: 'column',
        data: []
      },
      {
        name: 'deflection',
        type: 'line',
        data: []
      }],
    options: {
      tooltip: {enabled: false},
      markers: {size: 3},
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '16px',
          colors: ['#686F8A', '#F39314']
        },
      },
      chart: {
        id: 'vuechart',
        toolbar: {
          enabled: false,
          show: false
          }
      },
      legend: {show: false},
      grid: {
        show: false,
        borderColor: '',
        strokeDashArray: 0
      },
      colors: ['#686F8A', '#F39314'],
      stroke: { width: [0, 2] },
      labels: [],
      xaxis: {
        labels: {
          show: true,
          style: {colors: '#F39314'}
        },
        axisTicks: {color: '#F39314'},
        axisBorder: {color: ''},
      },
      yaxis: [
        {
          title: {},
          labels: {show: false}
        },
        {
            title: {},
            labels: {
                show: false
        }
      }],
      defaultLocale: 'ru',
      locales: [{
          "name": "ru",
          "options": {
              "months": ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
              "shortMonths": ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
              "days": ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
              "shortDays": ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
              "toolbar": {
              "exportToSVG": "Сохранить SVG",
              "exportToPNG": "Сохранить PNG",
              "menu": "Меню",
              "selection": "Выбор",
              "selectionZoom": "Выбор с увеличением",
              "zoomIn": "Увеличить",
              "zoomOut": "Уменьшить",
              "pan": "Перемещение",
              "reset": "Сбросить увеличение"
                  }
              }
          }]
    },
}),

computed: {

  ...mapState(['totalInfo']),

  today: function() {
      if (Object.keys(this.shop).length > 0 &&
          this.shop.workingDays.length > 0) {
          return this.shop.workingDays[this.shop.workingDays.length - 1];
      }
      return {};
  }

},

methods: {

  update () {
    this.graph = false;
    for (let el of this.totalInfo.shops){
        if (el.ID == this.shopid) {
          let days = el.workingDays.slice(-7);
          let deflection = [];
          let fact = [];
          let day = [];
          for (let el of days){
              deflection.push(el.deflection);
              fact.push((el.factM / 1000).toFixed());
              day.push(String(new Date(el.date).getDate()));
          }
          for (let el of this.series){
              if (el.name == 'sellings') el.data = fact;
              if (el.name == 'deflection') el.data = deflection;
          }
          this.options.labels = day;
          setTimeout(() => this.graph = true, 200);
          this.shop = el;
        }
    }
  }
    
},

watch: {

  totalInfo () {
    this.update();
  }


},

created: function() {
  this.update();
}

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
